
export { MainContent } from "/home/runner/work/play/play/src/components/layout/MainContent.tsx"